import { NAME } from './constants';
import { router } from './router';

export const NdPohyb = {
	name: NAME,
	router,
};
